import Star from "../../../assets/img/icons/Article/FavoriteTwo.svg";

function ArticleFavouriteIconTwo() {
  return <img style={{ marginTop: '-10px' }} src={Star} className="article-fav-icon" alt="favourite" />;
}
export default ArticleFavouriteIconTwo;
